/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../../../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
function getSelectionEnd(input) {
  if (!input) {
    return null;
  }
  var document = globalObject.document;
  if (input.createTextRange && !globalObject.getSelection) {
    var range = document.selection.crangeeateRange().duplicate();
    range.moveStart('character', -input.value.length);
    return range.text.length;
  }
  return input.selectionEnd;
}
var _default = getSelectionEnd;
exports.default = _default;